import {
  Project as OriginalProjectType,
  MemberList,
  ProjectMemberAdditionalRole,
  ProjectActivity,
  ProjectStack,
} from '@shared/types';

export enum PROJECT_DATE_STATUS {
  JOINED = 'joined',
  RESUMED = 'resumed',
  LEFT = 'left',
  PAUSED = 'paused',
  COMPLETED = 'completed',
  ARCHIVED = 'archived',
  UNARCHIVED = 'unarchived',
}

export enum PROJECT_TECH_STACKS_ACTIONS {
  ADD = 'ADD',
  REMOVE = 'REMOVE',
}

export enum PROJECT_INFO_ACTIONS {
  UPDATE = 'UPDATE',
  ADD = 'ADD',
}

export enum PROJECT_INFO_GROUPS {
  BASIC_INFO = 'BASIC_INFO',
  EVENTS = 'EVENTS',
  MEMBERS = 'MEMBERS',
  TECHNICAL_STACKS = 'TECHNICAL_STACKS',
}

export enum PROJECT_INFO_FIELD {
  NAME = 'NAME',
  DESCRIPTION = 'DESCRIPTION',
}

/**
 * Project event names for status-affecting activities
 */
export enum ProjectEventName {
  KICK_OFF = 'KICK_OFF',
  PAUSE = 'PAUSE',
  RESUME = 'RESUME',
  ARCHIVE = 'ARCHIVE',
  UNARCHIVE = 'UNARCHIVE',
  COMPLETE = 'COMPLETE',
  GO_LIVE = 'GO_LIVE',
  RELEASE = 'RELEASE',
}

/**
 * Project event args from chatbot
 */
export type ProjectEvent = {
  name?: ProjectEventName | string;
  description?: string;
  dateTime?: string;
};

export type Project = OriginalProjectType & {
  members?: MemberList;
  setProject?: (project: Project) => void;
};

export type CONTENT_TOOLTIP =
  | 'Project Information'
  | 'Technical Stacks'
  | 'Project Member'
  | 'Project Activities';

export type ActivityDateStatus = {
  date: Date;
  type: PROJECT_DATE_STATUS;
};

export type ProjectStageProps = {
  projectId?: string;
  uploadImage?: File;
  saveUploadImage?: (value: File | null | undefined) => void;
};

export type MemberParameter = {
  username: string;
  role: string;
};

// Project activity args
export type ProjectActivityArgs = {
  // Basic information
  name?: string;
  logo?: string;
  code?: string;
  desc?: string;
  stacks?: ProjectStack[];

  // Activity/Event related
  event?: string;
  rawMessage?: string;
  activity?: Project['projectInfo'] | ProjectActivity; // For storing the response project data or activity data
};

// Project member action types for employee project info card
export enum EmployeeProjectAction {
  INVITE_MEMBER = 'INVITE_MEMBER',
  REMOVE_MEMBER = 'REMOVE_MEMBER',
  LEAVE_MEMBER = 'LEAVE_MEMBER',
  RESUME_MEMBER = 'RESUME_MEMBER',
  CHANGE_ROLE_MEMBER = 'CHANGE_ROLE_MEMBER',
}

export type EmployeeProjectInfoCardData = {
  action: EmployeeProjectAction;
  projectCode: string;
  role: string;
  mode?: ProjectMemberAdditionalRole;
  updatedAt?: string;
};
